<div class="indicator-content">
  <div class="indicator-header">
    <span class="indicator-title">Indicador de Movimentação por Unidade <b>(R$)</b></span>
    <div fxLayoutAlign="end center">
      <indicator-filter (filterDataEvent)="onFilterData($event)" [companyName]="companyName" indicatorName="company-subsidiary-balance"></indicator-filter>
    </div>
  </div>
  <div *ngIf="isLoading" class="loader-container">
    <indicator-loader></indicator-loader>
  </div>
  <div *ngIf="!isLoading">
    <div *ngIf="hasCompanySubsidiaryBalanceData()" class="indicator-content-container">
      <canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="'line'"></canvas>
    </div>
    <div *ngIf="!hasCompanySubsidiaryBalanceData()" class="no-results">
      <p>Não foram encontrados resultados.</p>
    </div>
  </div>
</div>
